import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$locale/resume-generator')({
  ssr: false, // CSR only - no SEO needed
})
